exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ProseMirror .bookSpecificContent{border:1px solid #ddd}.ProseMirror-BookSpecific-Tooltip{position:absolute;padding:0 5px;border:1px solid #ddd;border-radius:4px;background-color:#fff;color:#000;font-weight:700;box-shadow:1px 2px 4px 0 rgba(0,0,0,.5);white-space:pre;z-index:1}", ""]);

// exports
